import { FC } from 'react'
import * as styles from 'styles/pages/Styleguide.css'
// import { FeedCompose } from 'components/features/socialFeed/FeedCompose/FeedCompose'
import { FeedDropZone } from 'components/features/socialFeed/FeedDropZone/FeedDropZone'

export const SGFeedPostCompose: FC = () => {
  return (
    <FeedDropZone>
      <div className={ styles.sgFeed }>
        <div className={ styles.post }>
          {/* <FeedCompose
            username='schasmar3s'
            role='post'
          /> */}
        </div>
      </div>
    </FeedDropZone>
  )
}
